import { Page } from "$components/page";
import { useQuerystring } from "$routes/_lib/use-querystring";
import { DateRangePicker } from "$routes/inventory/_lib/date-range-picker";
import InventoryTitleRow from "$routes/inventory/_lib/inventory-title-row";
import { LocationSelectWithAllOption } from "$routes/inventory/_lib/location-select-with-all-option";
import {
  linkToHistoricStockTakeOverview,
  linkToInventory,
  linkToStockTakeHistory,
} from "$routes/inventory/links";
import { Box, Grid } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import StockTakesTable from "./_lib/stock-takes-table";

const StockTakeHistory = (): JSX.Element => {
  const navigate = useNavigate();

  const queryParams = useQuerystring();

  const { locationId, startDate = null, endDate = null } = queryParams;

  const setLocationId = (val: string) =>
    navigate(linkToStockTakeHistory({ ...queryParams, locationId: val }));
  const setStartDate = (val: string) =>
    navigate(linkToStockTakeHistory({ ...queryParams, startDate: val }));
  const setEndDate = (val: string) =>
    navigate(linkToStockTakeHistory({ ...queryParams, endDate: val }));

  return (
    <Page data-dense>
      <InventoryTitleRow
        title={
          <FormattedMessage
            id="inventory.stockTake.history.title"
            defaultMessage="Stocktake History"
          />
        }
        backToLink={linkToInventory()}
      >
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12} sm={6}>
            <LocationSelectWithAllOption
              value={locationId}
              onChange={setLocationId}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <DateRangePicker
                hideHelper
                fromValue={startDate}
                setFromValue={setStartDate}
                toValue={endDate}
                setToValue={setEndDate}
              />
            </Box>
          </Grid>
        </Grid>
      </InventoryTitleRow>

      <StockTakesTable
        onRowClick={(stockTakeId) =>
          navigate(linkToHistoricStockTakeOverview(stockTakeId))
        }
        locationId={locationId}
        startDate={startDate}
        endDate={endDate}
      />
    </Page>
  );
};

export default StockTakeHistory;
